import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useParams } from "react-router-dom";
import { getPostsById } from "../../../../../redux/posts/action";
import { useDispatch, useSelector } from "react-redux";
import ManageAppliedProjectDetails from "./ManageAppliedProjectDetails";
import ManageAppliedProjectProposal from "./ManageAppliedProjectProposal";
import ManageAppliedProjectOffers from "./ManageAppliedProjectOffers";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";

export default function ManageAppliedProjectTabs() {
  const { urlstate, setManageAppliedprojectroute } = useRouteBaseStateContext();
  const { id } = useParams();
  const path = "Assets/scss/FindWork.module.scss";
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("ProjectDetails"); // State to track active tab
  const [pd, setPd] = useState(null);

  const posts = useSelector(({ posts: { postbyid } }) => postbyid);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (posts?.my_proposal && posts.my_proposal.length > 0) {
      setPd(posts.my_proposal[0]);
    }
    else if (posts.my_proposal_declined && posts.my_proposal_declined.length > 0) {
      setPd(posts.my_proposal_declined[0]);
    } else {
      setPd(null);
    }
  }, [posts]);

  useEffect(() => {
    if (urlstate?.manageappliedprojectroute) {
      setActiveTab(urlstate?.manageappliedprojectroute || "ProjectDetails");
    } else {
      setActiveTab("ProjectDetails");
    }
  }, [urlstate, urlstate?.manageappliedprojectroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setManageAppliedprojectroute(tab);
  };

  return (
    <div className="project-section">
      <h4>{posts?.title}</h4>
      <div className="col-12">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "ProjectDetails" ? "active" : ""}`}
              onClick={() => handleTabClick("ProjectDetails")}
            >
              Project Details
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "ProjectProposal" ? "active" : ""}`}
              onClick={() => handleTabClick("ProjectProposal")}
            >
              My Proposal
            </a>
          </li>
          {/* {pd?.status == 3 && pd?.milestones[0]?.payment_status == 1 && ( */}
          {
            Array.isArray(pd?.milestones) && pd?.milestones[0]?.payment_status == 0 ? <></> :
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab == "ProjectOffers" ? "active" : ""}`}
                  onClick={() => handleTabClick("ProjectOffers")}
                >
                  Offers
                </a>
              </li>
          }
          {/* )} */}
        </ul>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "ProjectDetails" ? "active" : ""}`}
            id="ProjectDetails"
          >
            <ManageAppliedProjectDetails posts={posts} />
          </div>
          <div
            className={`tab-pane ${activeTab == "ProjectProposal" ? "active" : ""}`}
            id="ProjectProposal"
          >
            <ManageAppliedProjectProposal pd={pd} />
          </div>
          <div
            className={`tab-pane ${activeTab == "ProjectOffers" ? "active" : ""}`}
            id="ProjectOffers"
          >
            <ManageAppliedProjectOffers posts={posts} pd={pd} />
          </div>
        </div>
      </div>
    </div>
  );
}
